/* global google */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Switch, Route, Redirect } from 'react-router-dom'

import withStore from 'with/Store'

import Modal from 'components/Modal'
import Button from 'components/buttons/Button'

import EnterCode from 'pages/EnterCode'
import Tracker from 'pages/Tracker'

import styles from './App.css'

import $tracker from 'utils/trackerService'

$tracker.enable()

@withRouter
@withStore(
  state => state.app
)
class App extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className={styles.App}>

        <Modal open={!!this.props.error} zIndex={20}>
          <h1>Ooops</h1>
          <p style={{fontSize: '1.6rem'}}>
            {this.props.error}
          </p>
          <br/>
          <Button 
            color='orange' 
            onClick={() => {
              this.props.dispatch({ type: 'HIDE_ERROR', payload: null })
            }}>
            OK 
          </Button>
        </Modal>

        <Switch>
          <Route path='/enterCode' component={EnterCode} />
          <Route path='/tracker' component={Tracker} />

          <Redirect to='/enterCode' />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js